import { useQuery } from 'react-query';
import { useApi } from 'hooks/useApi';
import ProjectsAPI from 'services/API/ProjectsAPI';
import type { ProjectWorkType, Project } from 'types';

export const useProjectWorkType = (projectSlug: Project['slug']) => {
  const api = useApi();

  return useQuery(
    ['get-project-work-type-information', projectSlug],
    async (): Promise<string[] | undefined> => {
      const response = await api.get<ProjectWorkType | null>(
        ProjectsAPI.getProjectWorkType(projectSlug),
      );

      return response?.work_type;
    },
    { refetchOnWindowFocus: false },
  );
};
